export default {"src":"/_next/static/media/gnosis.b5d69c43.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};